import ChangePasswordPage from "Pages/Authentication/ChangePasswordPage";
import ForgetPasswordPage from "Pages/Authentication/ForgetPasswordPage";
import LoginPage from "Pages/Authentication/LoginPage";
import PasswordUpdatePage from "Pages/Authentication/PasswordUpdatePage";
import EnquiryPage from "Pages/Enquiry/EnquiryPage";
import ListOfProjects from "Pages/Projects/ListOfProjects";
import ProjectsPage from "Pages/Projects/ProjectsPage";

import { Navigate } from "react-router-dom";

const authProtectedRoutes = [
{path: "/change-password", component: <ChangePasswordPage/>},
{path: "/add-project", component: <ProjectsPage/>},
{path: "/edit-project/:id", component: <ProjectsPage/>},
{path:"/projects",component: <ListOfProjects/>},
{path: "/inquiry", component: <EnquiryPage/>},

  {
    path: "/",
    exact: true,
    component: <Navigate to="/projects" />,
  },
  { path: "*", component: <Navigate to="/projects" /> },
];

const publicRoutes = [
  {path: "/login", component: <LoginPage/>},
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/update-password", component: <PasswordUpdatePage /> }
];

export { authProtectedRoutes, publicRoutes };